import isThrottled from './isThrottled';
import {default as requestIdleCallback, requestIdleCallbackPollyfill} from './requestIdleCallback';

export default function whenIdle(fn) {
	return isThrottled() ? requestIdleCallbackPollyfill(fn) : requestIdleCallback(fn);
}
